import {Component, Input, OnChanges, OnInit, SimpleChanges, Inject} from '@angular/core';
import { EventsDetailByVenue } from '@biletix/core/models/event/events-detail-by-venue.model';
import {TranslateService} from "@ngx-translate/core";
import {Locale, Region} from "@biletix/core/common"
import { RegionService } from '@biletix/core/services/region.service';
import {I18nService} from "@biletix/core/services/i18n.service";
import {BtxPerformanceListItem} from "@biletix/core/models/event/performance-list-item.model";
import { APP_BASE_HREF } from "@angular/common";
import { ImageUrlManager } from '@biletix/core/common/helper/image-url-manager';

@Component({
    standalone: false,
    selector: 'btx-venue-list-item',
    templateUrl: './venue-list-item.component.html',
    styleUrls: ['./venue-list-item.component.scss']
})
export class VenueListItemComponent implements OnInit, OnChanges {

    @Input() listItem!: BtxPerformanceListItem;
    regions: Region[];
    currentRegion: string;
    locales: Locale[];
    currentLocale: Locale;
    currentLang: string;
    @Input() lang?: string;

    date: string | number | Date = new Date();
    firstDate: string | number | Date = new Date();
    lastDate: string | number | Date = new Date();

    timeFormat = "HH:mm"
    fullDateFormat = "EEEE, d MMMM yyyy"
    dayFormat = "d"
    monthFormat = "LLLL"
    mobileDayFormat = "dd"
    mobileMonthFormat = "MMM"

    statusText: string = '';

    constructor(private translateService: TranslateService,public region: RegionService,public i18n: I18nService,@Inject(APP_BASE_HREF) private baseHref: string) {
        this.locales = this.i18n.getAvailableLocales();
        this.currentLocale = this.i18n.currentLocale;
        this.currentLang = this.currentLocale.lang
        this.regions = this.region.getRegions();
        this.currentRegion = this.region.currentRegion.name;
    }

    ngOnInit(): void {
      this.firstDate = this.listItem.firstPerformanceDate as Date;
      this.lastDate = this.listItem.lastPerformanceDate as Date;
      this.date = this.listItem.performanceDate as Date;
      this.statusText = this.translateService.instant("performance.status." + this.listItem?.status);
    }

    ngOnChanges(changes: SimpleChanges): void {
      this.firstDate = this.listItem.firstPerformanceDate as Date;
      this.lastDate = this.listItem.lastPerformanceDate as Date;
      this.date = this.listItem.performanceDate as Date;
      this.statusText = this.translateService.instant("performance.status." + this.listItem?.status);
    }

    generateHref(eventCode?: string, region?: string, lang?: string, keyUrlText?: string): string {
      if (!eventCode || !region || !lang) {
        return ''; 
      }
      if (keyUrlText) {
        return `${this.baseHref}etkinlik/${eventCode}/${region}/${lang}/${keyUrlText}`;
      }
      return `${this.baseHref}etkinlik/${eventCode}/${region}/${lang}`;
    }

    isNoImage(src?: string | null): boolean {
        return !src || !src.trim() || src.includes('noimage');
    }

    onImageError(event: Event): void {
        const imgElement = event.target as HTMLImageElement;
        if (imgElement && !imgElement.src.includes('noimage.gif')) {
            imgElement.src = ImageUrlManager.createEventImage('noimage.gif');
        }
    }

    // performanceItemClasses() {
    //     return {
    //         'sold-out': !this.listItem.active
    //     }
    // }

    statusClasses() {
        return {
            success: this.listItem.status === "s01_onsale",
            'status-sold-out': this.listItem.status === "s02_soldout",
            'status-soon': this.listItem.status === "s03_soon",
            'status-canceled': this.listItem.status === "s04_canceled",
            'status-postponed': this.listItem.status === "s05_postponed",
            'status-boxoffice': this.listItem.status === "s06_boxoffice",
            'status-otherchannelwbox': this.listItem.status === "s15_other_channel_list_with_boxoffice",
            'status-checkback': this.listItem.status === "s12_check_back_later",
            'status-oldover': this.listItem.status === "s13_old_over",
            'status-other': this.listItem.status === "s14_other_channels"
        }
    }
}
